// extracted by mini-css-extract-plugin
module.exports = {"list":"az_GQc","--fullWidth":"az_HQc"};